export const JUSBRASIL_NEWS_GA4 = {
  componentClass: 'topbar_user_menu',
  componentName: 'jusbrasil_news_cta',
  selectedOption: 'jusbrasil_news',
} as const
